<template>
    <section  ref="insta" class="container margin-both-lg">
        
        <div class="inner">
            <h2 class="insta-title" v-if="data.title">{{data.title}}</h2>
            <div class="insta-feed cached" v-if="!feed" v-html="instagramData"  v-once/>
            <div class="insta-feed refreshed" v-if="feed" v-html="feed"  v-once/>
        </div>
    </section>
</template>

<script>
//we're using too feeds to display, one is cached during save post, second one is loaded fresh one.
// We using cached during post save to show immiditly something, and then it is replaced by fresh loaded, 
// second is because async get for WP and shortcode some time can be long, so we dont want to wait like  5 sec till anything is loaded

window.$ = window.jQuery;
import 'owl.carousel'
import { arrow } from '@/components/../icons';

export default {
    name: 'instagram-module',
    props: ['data'],
    components: {
    },
    data(){
        return{
            feed: '',
            arrowIcon : arrow('#00344D'),
            instagramData : this.data.instagram_meta ? this.data.instagram_meta.replace(/\\/g, "") : ''
        }
    },
    mounted(){
       this.loadInstaFreshData();
       if(this.instagramData){
            this.triggerCarousel()
       }
    },
    computed:{

    },
    methods: {
        triggerCarousel( classed = 'cached' ){
            const jQuery = window.$;
            const VM = this;
            const SBICont = jQuery(document).find( '.'+classed+' #sbi_images');
            if(SBICont.length){
                jQuery(SBICont).addClass('owl-carousel').owlCarousel({
                    loop:true,
                    margin:20,
                    responsiveClass:true,
                    navText: [VM.arrowIcon,VM.arrowIcon],
                    nav: true,
                    responsive:{
                        0:{
                            items:2,
                            margin:10,
                            center: true,
                            nav: false,
                        },
                        600:{
                            items:3,
                        },
                        1000:{
                            items:4,
                        }
                    }
                })
            }
        },
        loadInstaFreshData(){
            const VM = this
            
            const apiUrl  = window.WPVUE.home.replace('/wp', '/')
            const url = apiUrl + '/wp-json/wpvue/v2/instafeed/'
            // eslint-disable-next-line no-undef
            axios.get(url, {
                params:{
                    stream_type: VM.data.stream_type,
                    hashtag: VM.data.hashtag
                }
            }).then(e=>{
                if(e.data.insta){
                   VM.feed = e.data.insta
                   VM.$nextTick(() => {
                       this.triggerCarousel('refreshed')

                   })
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

    .module-instagram{
        overflow: hidden;
        max-width: 100vw;
        .inner{
            background: #fff;
            padding: 25px;
            border-radius: $blocksRadius;
            .owl-stage-outer{
                overflow: hidden;
            }
            @include mquery($phone){
                padding: 15px;
                .owl-carousel .owl-stage-outer{
                    overflow: visible;
                }
            }
        }
        .owl-stage{
            display: flex;
        }
        .insta-title{
            margin-top: 0;
            text-align: center;
        }
        #sb_instagram{
            max-width: 840px;
            margin-left: auto;
            margin-right: auto;
        }
        .owl-dots{
            display: none;
        }
        .owl-nav{

            button{
                border: none;
                background-color: transparent;
                -webkit-appearance: none;
                box-shadow: none;
                cursor: pointer;
                @include mquery($phone){
                    display: none;
                }

            }
            .owl-prev, .owl-next{
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                &.disabled{
                    opacity: 0.5;
                }
            }
            .owl-prev{
                left: -35px;
                @include mquery(900px){
                    left: -25px;
                }
            }
            .owl-next{
                right: -35px;
                @include mquery(900px){
                    right: -25px;
                }
                svg{
                    transform: rotate(180deg) translateY(1px);
                }
            }
        }
        #sbi_images{
            position: relative;
            max-height: 400px;
            padding: 0 !important;
        }
        #sbi_mod_error{
            display: none !important;
        }
        .sbi_info{
            display: none;
        }
        .sbi_follow_btn{
            display: block;
            text-transform: uppercase;
            text-align: center;
            margin-top: 25px;
            @include fluid-type($smallResText, $wideResText, 12px, 14px);
            a{
                text-decoration: none;
                font-weight: bold;
                position: relative;
                &:after{
                    transform: translateY(2px);
                    display: inline-block;
                    margin-left: 10px;
                    content: url("data:image/svg+xml;charset=UTF-8,%3csvg width='20' height='13' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M.866 5.339h16.178l-3.86-3.861A.865.865 0 1114.408.254l5.338 5.338a.865.865 0 010 1.224l-5.338 5.339a.862.862 0 01-1.224 0 .865.865 0 010-1.224l3.86-3.861H.866a.866.866 0 010-1.731z' fill='%2300344D'/%3e%3c/svg%3e");
                }

            }
            svg{
                display: none;
            }

        }
        .sbi-screenreader{
            position: absolute;
            top: 50px;
            font-size: 10px;
        }
        .sbi_photo_wrap{
            position: relative;
            svg{
                position: absolute;
                z-index: 10;
                width: 20px;
                height: 20px;
                right: 20px;
                top: 10px;
                &.fa-play, &.fa-clock {
                    display: none;
                }
            }
            .sbi_lightbox_carousel_icon{
                display: none;
            }
            .sbi_link{
                position: absolute;
                width: 100%;
            }
            .sbi_photo{
                display: block;
                overflow: hidden;
                border-radius: $blocksRadius;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: $blocksRadius;
                    position: absolute;
                    z-index: 2;
                    font-size: 10px;
                    object-fit: cover;
                }
            }
        }
    }
</style>